export const types = {

    login: '[Auth] Login',
    logout: '[Auth] Logout',

    userLoadData: "[User] Load User Data",

    userCoursesUpdated: "[Auth] RealTime User Courses Update",

    uiOpenModal: "[ui] Open Modal",
    uiCloseModal: "[ui] Close Modal",


    eventSetActive: "[event] Set Active",
    eventAddNew: "[event] Add New",


    uiStartLoading: "[ui] Start Loading",
    uiFinishLoading: "[ui] Finish Loading",

    alumnoLogoutCleaning: '[Alumno] Logout Cleaning',
}